import React, {useEffect, useRef, useState} from "react";
import * as Yup from "yup";
import {useSelector} from "react-redux";
import {RootState} from "../../../../../reducers";
import {useActions} from "../../../../../actions";
import * as Actions from "../../../../../actions/account";
import * as Estimations from "../../../../../actions/estimation";
import {
    AccountType,
    AllianzLifeCarrierDetail,
    GWT_GEN2_STRATEGY, GWTVersionEnum,
    minContributionAmount,
    otherIndustryId,
    stateDropDown,
    USA,
} from "../../../../../constants";
import moment from "moment";
import AllianzAlert from "../../component/AllianzAlert";
import IncomeAlert from "../../component/IncomeAlert";
import { asDbDateTimeFormat, DATE_FORMAT_DOB_SAVE, getCurrentYear } from "../../../../../utils/dateUtils";
import numeral from "numeral";
import {PhysicianAndMedicalDetailsStyle} from "../EnrollmentApplication/MedicalAndFinancial/medicalStyle";
import {scroller} from "react-scroll";
import KickOut from "../../component/EnrollmentHome/KickOut";
import PersonalDetailFormikContent, { incomeDetailsColArr } from "./PersonalDetailFormikContent";
import PersonalDetailValidate from "./PersonalDetailValidate";
import CommonFieldFunction from "./CommonFieldFunction";
import {formatSSN} from "./PersonalDetailUtils";
import PersonalDetailFieldObj from "./PersonalDetailFieldObj";
import UpdateEmailReqPopUp from "./UpdateEmailReqPopUp";
import { convertToNumber, isLongForm, isWorksheet } from "../EnrollmentApplication/Utilities";
import { useOfferType } from "../../../../../hooks/useOfferType";
import { isNfIulCase } from "../../../../../utils/commonFunc";


const initVal = {
    proofExpiryYear: 0,
    proofExpiryMonth: 0,
    gender: "",
    immigrationStatus: "",
    residenceInHomeCountry: "",
    currentlyEmployed: "",
    currentlyEmployedSelf: "",
    marriageStatus: "",
    employedTime: 0,
    industryId: 0,
    occupationId: 0,
    healthType: "",
    parentsAreIncomeEarner: "",
    birthState: ""
}

const PersonalDetailFormV2 = (props: { setNextStep: Function, setActionItem: Function, isFromClientDetail?: boolean,
    clientDetail?: any, setPersonalDetailRef?: Function, setIsPersonalFormDirty?: Function, setIsFormSubmitting?: Function,
    setCarrierValAlert?: Function, setValidationError?: Function, setStateValue?: Function, communityStateVal?: string,
    setCommunityStateVal?: Function, setIsDocumentAddress?: Function, getClientDetail?: Function, urlClientId?: string, ssnFlag?: boolean, clientPolicyId?: string, autoSaveEnable?: boolean}) => {
    const classes = PhysicianAndMedicalDetailsStyle();
    const {
        setNextStep,
        isFromClientDetail,
        setPersonalDetailRef,
        setIsPersonalFormDirty,
        setIsFormSubmitting,
        setCarrierValAlert,
        setActionItem,
        setValidationError,
        setStateValue,
        communityStateVal,
        setCommunityStateVal,
        getClientDetail, urlClientId, ssnFlag,
        clientPolicyId,
        autoSaveEnable = true
    } = props;

    const accountActions = useActions(Actions);
    const estimationActions = useActions(Estimations);
    const {setIsDocumentAddress}= props;
    let userData = useSelector((state: RootState) => state.profile);
    let { user: { role, participant } } = useSelector((state: RootState) => state.auth);
    let isGiftor = participant && participant.subType  == "Giftor"
    let user = props.clientDetail;
    if (userData.role === AccountType.Individual || userData.role === AccountType.Multilife) {
        user = userData;
    }
    const { client } = user;
    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0];
    const conditionalRequired = !(role === 1 || role === 2 || role === 4);
    const [selfEmployed, setSelfEmployed] = React.useState(false);
    const [currentlyEmployed, setCurrentlyEmployed] = React.useState<string>("");
    const [fullTimeEmployee, setFullTimeEmployee] = React.useState<number>(1);
    const [carrierId, setCarrierId] = React.useState<number | null>(null);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [allianzId, setAllianzId] = React.useState<number | null>(null);
    const [carrierName, setCarrierName] = React.useState<string | undefined>("");
    const [minVal, setMinVal] = React.useState(minContributionAmount);
    const [ageSelected, setAgeSelected] = React.useState(false);
    const [incomeAlertOpen, setIncomeAlertOpen] = React.useState(false);
    const [proofExpired, setProofExpired] = React.useState(false);
    const [nationalLifeId, setNationalLifeId] = React.useState<number | null>(null);
    const [isNationalLife, setIsNationalLife] = React.useState<boolean>(false);
    const [isAllianzLife, setIsAllianzLife] = React.useState<boolean>(false);
    const [minAge, setMinAge] = React.useState<number>(25);
    const [strategySlug, setStrategySlug] = React.useState("");
    const [labelsActive, setLabelsActive] = React.useState<any[]>([]);
    const isNfIul = isNfIulCase((clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id) as number, strategySlug);
    const [refresh, setRefresh] = React.useState(0);
    const [stateObj, setStateObj] = React.useState<{} | string>("");
    const currentYear = getCurrentYear();
    const personalDetailSubmit = React.useRef<any>();
    const proofExpireRef: any = useRef(null);
    const personalDetailForm:any = React.useRef<any>(null);
    const [isFormSubmit, setIsFormSubmit] = React.useState<boolean>(false);
    const [identityType, setIdentityType] = React.useState<string>("");
    const [openKickOutPopup, setOpenKickOutPopup] = useState(false);
    const [fullTimeSelected, setFullTimeSelected] = useState(0);
    const [middleNameExist, setMiddleNameExist] = React.useState(false);
    const [isMarried, setIsMarried] = useState(false);
    const [isEmployed, setIsEmployed] = useState(false);
    const [provideCorrectEmailPopUp, setProvideCorrectEmailPopUp] = useState(false);
    const [isParentEarner, setIsParentEarner] = React.useState<boolean>(false);
    //const [isDobRefresh, setIsDobRefresh] = React.useState<number>(0);
    const [saveRequest, sendSaveRequest] = React.useState<any>(-1);
    const [formValues, setFormValues] = React.useState<any>({});
    const [industryDropDown, setIndustryDropDown] = React.useState([]);
    const [isIndustryOther, setIsIndustryOther] = React.useState(false);
    const [industryId, setIndustryId] = React.useState(0);
    const [occupationDropDownArr, setOccupationDropDownArr] = React.useState([]);
    const [serverError, setServerError] = React.useState(false);
    const [birthCountryValue, setBirthCountryValue] = React.useState<string>(client && client.birthCountry);
    const [birthStateValue, setBirthStateValue] = React.useState<string>(client && client.birthState);
    const [otherCitizenshipValue, setOtherCitizenshipValue]= React.useState(clientPolicy && clientPolicy.otherCitizenship);
    const [countryCitizenshipValue, setCountryCitizenshipValue] = React.useState(clientPolicy && clientPolicy.countryCitizenship);
    const clientSigned = (clientPolicy && clientPolicy.enrollment && (clientPolicy.enrollment.clientSigned || clientPolicy.enrollment.envelopeId)) ? 1 : 0; // check envelopId generated too

    const getAllianzCarrierDetails = async () => {
        const allianzData = await accountActions.getAllianzDetails();
        if (allianzData && allianzData.allianzLife && allianzData.allianzLife.id) {
            setAllianzId(allianzData.allianzLife.id);
        }
    };
    const getNatioanlLifeCarrierDetails = async () => {
        const nationalLifeDate = await accountActions.getNationalLifeDetails();
        if (nationalLifeDate && nationalLifeDate.nationalLife) {
            setNationalLifeId(nationalLifeDate.nationalLife.id);
        }
    };

    const scrollUp = async (id) => {
        setIsFormSubmit(false);
        scroller.scrollTo(id, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
            offset: -200,
        });
        return await accountActions.setSnackBarMessage(false, `${identityType === "drivingLicence" ? "Drivers license" : "Passport"} has been expired`);
    }

    const getOccupationList = async (industryId: number) => {
        const res = await accountActions.getOccupationByIndustryId({industryId});
        const resArr = res.length > 0 && res.map((item) => {
            return {
                id: item.id,
                value: item.id,
                name: item.occupationDefinition
            }
        })
        setOccupationDropDownArr(resArr);
    }
    const [initialValues, setInitialValues] = React.useState<any>(initVal);
    let dob = user && user.client && user.client.dob;
    const isGWTGen2 = (clientPolicy && clientPolicy.strategyId === GWT_GEN2_STRATEGY);
    const isGWTGenV2 = (user && user.client && user.client.gwtVersion === GWTVersionEnum.Two);
    const financiallyDependent: boolean = clientPolicy && clientPolicy.financiallyDependent;
    const gwtV2FD = isGWTGenV2 ? !financiallyDependent : true;
    useEffect(() => {
        let proofExpireDate = clientPolicy && clientPolicy.employeeIdExpireDate;
        let proofExpiryYear = 0;
        let proofExpiryMonth = 0;
        if (proofExpireDate) {
            let proofExpireDateArr = proofExpireDate.split("-");
            proofExpiryYear = Number(proofExpireDateArr[0]);
            proofExpiryMonth = Number(proofExpireDateArr[1]);
        }
        let formVal:any = {
            proofExpiryYear: proofExpiryYear,
            proofExpiryMonth: proofExpiryMonth
        };
        const greenCardExpiryDate = clientPolicy && clientPolicy.greenCardExpiryDate;
        const greenCardExpiryYear = moment(greenCardExpiryDate).format('YYYY');
        const greenCardExpiryMonth = moment(greenCardExpiryDate).format('M');

        const visaExpiryDate = clientPolicy && clientPolicy.visaExpiryDate;
        const visaExpiryYear = moment(visaExpiryDate).format('YYYY');
        const visaExpiryMonth = moment(visaExpiryDate).format('M');

        if(client){
            formVal = {
                ...formVal,
                firstName: user.firstName || "",
                middleName: user.middleName || "",
                mnNotRequired: user.mnNotRequired || false,
                lastName: user.lastName || "",
                cellPhone: user.phoneNumber || "",
                email: user.email || "",
                usCitizen: !!(clientPolicy && clientPolicy.usCitizen),
                identityType: clientPolicy && clientPolicy.identityType || "drivingLicence",
                identityId: clientPolicy && clientPolicy.employeeIdNumber || "",
                employeeSSN: formatSSN(client.employeeSSN || ""),
                blotSSN: client && client.blotSSN || "",
                birthState: birthStateValue,
                birthCountry: client && client.birthCountry || "",
                workPhoneNumber: client && client.workPhoneNumber || "",
                homePhone: client && client.homePhone || "",
                gender: client && client.gender || "",
                dob: asDbDateTimeFormat(client.dob, DATE_FORMAT_DOB_SAVE),
                age: moment().diff(asDbDateTimeFormat(client.dob, DATE_FORMAT_DOB_SAVE), "years") || client.age,
                street: client.street || "",
                city: client.city || "",
                state: stateObj || {key: "", name: "", title: ""},
                zipCode: client.zipCode || "",
                isDocumentAddress: !!(clientPolicy && clientPolicy.isDocumentAddress),
                selfEmployed: (clientPolicy && clientPolicy.selfEmployed || clientPolicy && clientPolicy.currentlyEmployed === "SELF_EMPLOYED"),
                currentlyEmployed: isGWTGenV2 ? (clientPolicy && clientPolicy.currentlyEmployed) : isGWTGen2 ? "Other" : clientPolicy && clientPolicy.currentlyEmployed || "",
                qualifiedIncomeEarner: !!(clientPolicy && clientPolicy.qualifiedIncomeEarner === 1),
                currentlyEmployedSelf : clientPolicy && clientPolicy.currentlyEmployedSelf || "",
                fullTimeEmployee : clientPolicy && clientPolicy.fullTimeEmployee,
                howLongInUS : clientPolicy && clientPolicy.howLongInUS || "",
                countryCitizenship : clientPolicy && clientPolicy.countryCitizenship || countryCitizenshipValue,
                immigrationStatus : clientPolicy && clientPolicy.immigrationStatus || "",
                greenCardNo : clientPolicy && clientPolicy.greenCardNo || "",
                greenCardExpiryMonth : greenCardExpiryDate ?  greenCardExpiryMonth : "",
                greenCardExpiryYear : greenCardExpiryDate ?  greenCardExpiryYear : "",
                typeOfVisaPlanHeld : clientPolicy && clientPolicy.typeOfVisaPlanHeld || "",
                visaExpiryMonth : visaExpiryDate ? visaExpiryMonth : "",
                visaExpiryYear : visaExpiryDate ? visaExpiryYear :  "",
                typeOfVisaHeld : clientPolicy && clientPolicy.typeOfVisaHeld || "",
                immigrationStatusOther : clientPolicy && clientPolicy.immigrationStatusOther || "",
                residenceInHomeCountry : clientPolicy && clientPolicy.residenceInHomeCountry || "0",
                residenceInHomeCountryExplain : clientPolicy && clientPolicy.residenceInHomeCountryExplain || "",
                employer: clientPolicy.employer ? clientPolicy.employer : (clientPolicy.company && clientPolicy.company.groupType === "Corporation") ? clientPolicy.company.companyName : "",
                employedTime: clientPolicy && clientPolicy.employedTime || "",
                annualIncome: (clientPolicy.annualIncome && numeral(clientPolicy.annualIncome).value() > 0 &&  Number(clientPolicy.annualIncome).toString()) || "",
                annualIncome1: (clientPolicy && clientPolicy.annualIncome1 && Number(clientPolicy && clientPolicy.annualIncome1).toString()) || "",
                annualIncome2: (clientPolicy && clientPolicy.annualIncome2 && Number(clientPolicy && clientPolicy.annualIncome2).toString()) || "",
                householdAnnualIncome: (clientPolicy && clientPolicy.householdAnnualIncome && Number(clientPolicy && clientPolicy.householdAnnualIncome).toString()) || "", //spouse annual income
                householdNetWorth: (clientPolicy && clientPolicy.householdNetWorth && Number(clientPolicy && clientPolicy.householdNetWorth).toString()) || (clientPolicy.netWorth && Number(clientPolicy.netWorth).toString()) || "",
                spouseDUAIncome: (clientPolicy && clientPolicy.spouseDUAIncome && Number(clientPolicy && clientPolicy.spouseDUAIncome).toString()) || "",
                householdLiquidAssets: (clientPolicy && clientPolicy.householdLiquidAssets && Number(clientPolicy && clientPolicy.householdLiquidAssets).toString()) || "",
                householdAnnualExpenses: (clientPolicy && clientPolicy.householdAnnualExpenses && Number(clientPolicy && clientPolicy.householdAnnualExpenses).toString()) || "",
                healthType: clientPolicy && clientPolicy.healthType || "",
                USBasedCompany: !!(clientPolicy && clientPolicy.USBasedCompany),
                employeeIdState: clientPolicy && clientPolicy.employeeIdState || "",
                netWorth: (clientPolicy.netWorth && numeral(clientPolicy.netWorth).value() > 0 && Number(clientPolicy.netWorth).toString()) || "",
                employerContribution: clientPolicy && clientPolicy.employerContribution || 0,
                contributionAmount: clientPolicy && clientPolicy.issuedContribution || clientPolicy && clientPolicy.contributionAmount || "",

                marriageStatus: (clientPolicy && clientPolicy.marriageStatus) || "", // income details new columns starts here
                spouse: (clientPolicy && clientPolicy.trustDetails && clientPolicy.trustDetails.spouse && clientPolicy.trustDetails.spouse.trim()) || "",
                usingSpouseIncome: isGWTGen2 ? "0" : clientPolicy && (typeof clientPolicy.usingSpouseIncome === "number") ? clientPolicy.usingSpouseIncome + "" : "",
                spouseIncome: (clientPolicy && clientPolicy.spouseIncome && Number(clientPolicy.spouseIncome).toString()) || "",

                indIncomeLastYearAnnualSalary: clientPolicy && (clientPolicy && clientPolicy.annualIncome && numeral(clientPolicy && clientPolicy.annualIncome).value() > 0 && Number(clientPolicy && clientPolicy.annualIncome).toString()) || "",
                indIncomeLastYearDividends: clientPolicy && (clientPolicy.indIncomeLastYearDividends && numeral(clientPolicy.indIncomeLastYearDividends).value() > 0 && Number(clientPolicy.indIncomeLastYearDividends).toString()) || "",
                indIncomeLastYearOtherIncome: clientPolicy && (clientPolicy.indIncomeLastYearOtherIncome && numeral(clientPolicy.indIncomeLastYearOtherIncome).value() > 0 && Number(clientPolicy.indIncomeLastYearOtherIncome).toString()) || "",
                indIncomeLastYearTotal: clientPolicy && (clientPolicy.indIncomeLastYearTotal && numeral(clientPolicy.indIncomeLastYearTotal).value() > 0 && Number(clientPolicy.indIncomeLastYearTotal).toString()) || "",

                indIncome1YearsPriorAnnualSalary: clientPolicy && (clientPolicy.annualIncome1 && numeral(clientPolicy.annualIncome1).value() > 0 && Number(clientPolicy.annualIncome1).toString()) || "",
                indIncome1YearsPriorDividends: clientPolicy && (clientPolicy.indIncome1YearsPriorDividends && numeral(clientPolicy.indIncome1YearsPriorDividends).value() > 0 && Number(clientPolicy.indIncome1YearsPriorDividends).toString()) || "",
                indIncome1YearsPriorOtherIncome: clientPolicy && (clientPolicy.indIncome1YearsPriorOtherIncome && numeral(clientPolicy.indIncome1YearsPriorOtherIncome).value() > 0 && Number(clientPolicy.indIncome1YearsPriorOtherIncome).toString()) || "",
                indIncome1YearsPriorTotal: clientPolicy && (clientPolicy.indIncome1YearsPriorTotal && numeral(clientPolicy.indIncome1YearsPriorTotal).value() > 0 && Number(clientPolicy.indIncome1YearsPriorTotal).toString()) || "",

                indIncome2YearsPriorAnnualSalary: clientPolicy && (clientPolicy.annualIncome2 && numeral(clientPolicy.annualIncome2).value() > 0 && Number(clientPolicy.annualIncome2).toString()) || "",
                indIncome2YearsPriorDividends: clientPolicy && (clientPolicy.indIncome2YearsPriorDividends && numeral(clientPolicy.indIncome2YearsPriorDividends).value() > 0 && Number(clientPolicy.indIncome2YearsPriorDividends).toString()) || "",
                indIncome2YearsPriorOtherIncome: clientPolicy && (clientPolicy.indIncome2YearsPriorOtherIncome && numeral(clientPolicy.indIncome2YearsPriorOtherIncome).value() > 0 && Number(clientPolicy.indIncome2YearsPriorOtherIncome).toString()) || "",
                indIncome2YearsPriorTotal: clientPolicy && (clientPolicy && clientPolicy.indIncome2YearsPriorTotal && numeral(clientPolicy.indIncome2YearsPriorTotal).value() > 0 && Number(clientPolicy.indIncome2YearsPriorTotal).toString()) || "",

                indOtherIncomeDetail: clientPolicy && clientPolicy.indOtherIncomeDetail || "",

                houseHoldIncomeLastYearAnnualSalary: clientPolicy && (clientPolicy.householdAnnualIncome && numeral(clientPolicy.householdAnnualIncome).value() > 0 && Number(clientPolicy.householdAnnualIncome).toString()) || "",
                houseHoldIncomeLastYearDividends: clientPolicy && (clientPolicy.houseHoldIncomeLastYearDividends && numeral(clientPolicy.houseHoldIncomeLastYearDividends).value() > 0 && Number(clientPolicy.houseHoldIncomeLastYearDividends).toString()) || "",
                houseHoldIncomeLastYearOtherIncome: clientPolicy && (clientPolicy.houseHoldIncomeLastYearOtherIncome && numeral(clientPolicy.houseHoldIncomeLastYearOtherIncome).value() > 0 && Number(clientPolicy.houseHoldIncomeLastYearOtherIncome).toString()) || "",
                houseHoldIncomeLastYearTotal: clientPolicy && (clientPolicy.houseHoldIncomeLastYearTotal && numeral(clientPolicy.houseHoldIncomeLastYearTotal).value() > 0 && Number(clientPolicy.houseHoldIncomeLastYearTotal).toString()) || "",

                houseHoldIncome1YearsPriorAnnualSalary: clientPolicy && (clientPolicy.houseHoldIncome1YearsPriorAnnualSalary && numeral(clientPolicy.houseHoldIncome1YearsPriorAnnualSalary).value() > 0 && Number(clientPolicy.houseHoldIncome1YearsPriorAnnualSalary).toString()) || "",
                houseHoldIncome1YearsPriorDividends: clientPolicy && (clientPolicy.houseHoldIncome1YearsPriorDividends && numeral(clientPolicy.houseHoldIncome1YearsPriorDividends).value() > 0 && Number(clientPolicy.houseHoldIncome1YearsPriorDividends).toString()) || "",
                houseHoldIncome1YearsPriorOtherIncome: clientPolicy && (clientPolicy.houseHoldIncome1YearsPriorOtherIncome && numeral(clientPolicy.houseHoldIncome1YearsPriorOtherIncome).value() > 0 && Number(clientPolicy.houseHoldIncome1YearsPriorOtherIncome).toString()) || "",
                houseHoldIncome1YearsPriorTotal: clientPolicy && (clientPolicy.houseHoldIncome1YearsPriorTotal && numeral(clientPolicy.houseHoldIncome1YearsPriorTotal).value() > 0 && Number(clientPolicy.houseHoldIncome1YearsPriorTotal).toString()) || "",

                houseHoldIncome2YearsPriorAnnualSalary: clientPolicy && (clientPolicy.houseHoldIncome2YearsPriorAnnualSalary && numeral(clientPolicy.houseHoldIncome2YearsPriorAnnualSalary).value() > 0 && Number(clientPolicy.houseHoldIncome2YearsPriorAnnualSalary).toString()) || "",
                houseHoldIncome2YearsPriorDividends: clientPolicy && (clientPolicy.houseHoldIncome2YearsPriorDividends && numeral(clientPolicy.houseHoldIncome2YearsPriorDividends).value() > 0 && Number(clientPolicy.houseHoldIncome2YearsPriorDividends).toString()) || "",
                houseHoldIncome2YearsPriorOtherIncome: clientPolicy && (clientPolicy.houseHoldIncome2YearsPriorOtherIncome && numeral(clientPolicy.houseHoldIncome2YearsPriorOtherIncome).value() > 0 && Number(clientPolicy.houseHoldIncome2YearsPriorOtherIncome).toString()) || "",
                houseHoldIncome2YearsPriorTotal: clientPolicy && (clientPolicy.houseHoldIncome2YearsPriorTotal && numeral(clientPolicy.houseHoldIncome2YearsPriorTotal).value() > 0 && Number(clientPolicy.houseHoldIncome2YearsPriorTotal).toString()) || "",

                houseHoldOtherIncomeDetail: clientPolicy && clientPolicy.houseHoldOtherIncomeDetail || "",
                parentsAreIncomeEarner: isGWTGenV2 ? (clientPolicy && clientPolicy.parentsAreIncomeEarner === 1 ? "1" : "0") : isGWTGen2 ? "1" : "0",

                occupation: clientPolicy && clientPolicy.occupation || "",

                industryId: clientPolicy && clientPolicy.industryId || null,
                occupationId: clientPolicy && clientPolicy.occupationId || null,
                otherOccupation: clientPolicy && clientPolicy.otherOccupation || "",
                occupationDetail: clientPolicy && clientPolicy.occupationDetail || "",
                employerAddress: clientPolicy && clientPolicy.employerAddress || "",
                highRanking: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy.clientSourceOfFund.highRanking,
                individualHighRanking: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy.clientSourceOfFund.individualHighRanking,
                workInIndustries: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy.clientSourceOfFund.workInIndustries,
                countryOfOrigin: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy.clientSourceOfFund.countryOfOrigin || "",
                sourceOfFunds: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy.clientSourceOfFund.sourceOfFunds || "",
                countrySourceOfWealth: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy.clientSourceOfFund.countrySourceOfWealth || "",
                whereTheyProceed: isGWTGen2 ? "Parents work income and net worth income being used as gift to child.":
                       clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy.clientSourceOfFund.whereTheyProceed || "",
                otherIndustry: clientPolicy && clientPolicy.otherIndustry || "",
                currentResidenceCountry: clientPolicy && clientPolicy.currentResidenceCountry || "",
                otherCitizenship: clientPolicy && clientPolicy.otherCitizenship || otherCitizenshipValue
            }
        }
        if (client && clientPolicy) {
            setInitialValues(formVal);
            setMiddleNameExist(user.mnNotRequired || false);
        }
    }, [client,clientPolicy, user]);

    React.useEffect(() => {
        if (birthCountryValue !== USA) {
            setInitialValues({ ...initialValues, birthState: "", birthCountry: birthCountryValue });
        }
    }, [birthCountryValue]);

    React.useEffect(() => {
        if (proofExpired && isFormSubmit && proofExpireRef && proofExpireRef.current) {
            scrollUp(proofExpireRef.current.id);
        }
    }, [proofExpired, isFormSubmit]);

    React.useEffect(() => {
        if (isNationalLife) {
            setMinAge(18); //for National Life Carrier MIN AGE is 18;
        }
    }, [isNationalLife]);

    React.useEffect(() => {
        if (isAllianzLife) {
            setMinAge(18); //for National Life Carrier MIN AGE is 18;
        }
    }, [isAllianzLife]);

    React.useEffect(() => {
        if (nationalLifeId && carrierId && nationalLifeId === carrierId && strategySlug === "kaizen") {
            setIsNationalLife(true);
        }
    }, [nationalLifeId, carrierId]);

    React.useEffect(() => {
        if (allianzId && carrierId && allianzId === carrierId && strategySlug === "kaizen") { //if Allianz Life and strategy is Kaizen
            setIsAllianzLife(true);
        }
    }, [allianzId, carrierId]);

    React.useEffect(() => {
        if (typeof setCarrierValAlert === "function") {
            setCarrierValAlert(openAlert);
        }
    }, [openAlert]);

    useEffect(() => {
        if (personalDetailSubmit.current && typeof setPersonalDetailRef === "function") {
            setPersonalDetailRef(personalDetailSubmit);
        }
    }, [personalDetailSubmit.current]);

    useEffect(() => {
        if (!isFromClientDetail) {
            accountActions.getProfileDetails();
        }
        getAllianzCarrierDetails().then(()=>{});
        getNatioanlLifeCarrierDetails().then(()=>{});
    }, []);

    useEffect(()=>{
        if(industryId){
            getOccupationList(industryId);
        }
    },[industryId])

    React.useEffect(() => {
        getEstimation().then(()=>{});
        getIndustriesList().then(() => {
        });
    }, []);

    useEffect(()=>{
        if(isFromClientDetail && communityStateVal){
            const stateList = JSON.parse(JSON.stringify(stateDropDown));
            const stateObjFound: any =  stateList.find((item:any,index)=>{
                return item.value === communityStateVal
            })
            if (stateObjFound) {
                setStateObj({
                    key: stateObjFound && stateObjFound.value,
                    name: stateObjFound && stateObjFound.name,
                    title: stateObjFound && stateObjFound.name
                });
                stateObjFound.key = stateObjFound && stateObjFound.value;
                stateObjFound.title = stateObjFound && stateObjFound.name;
                delete stateObjFound.isCommunityState;
                delete stateObjFound.id;
                delete stateObjFound.value;
                setTimeout(() => {
                    setInitialValues(Object.assign({}, {...initialValues, state: stateObjFound}))
                }, 500);
                setTimeout(() => {
                    if (typeof setCommunityStateVal === 'function') {
                        setCommunityStateVal("");
                    }
                }, 1000)
            }
        }

    },[communityStateVal])

    useEffect(() => {
        if (clientPolicy) {
            setIdentityType((clientPolicy && clientPolicy.identityType) || "");
            setSelfEmployed(!!(clientPolicy && clientPolicy.selfEmployed));
            setCurrentlyEmployed(clientPolicy && clientPolicy.currentlyEmployed || "");
            setFullTimeEmployee(clientPolicy && clientPolicy.fullTimeEmployee);
            setFullTimeSelected(clientPolicy && clientPolicy.currentlyEmployed === 'FULL_TIME' ? 1 : 0)

            setIsMarried(clientPolicy && clientPolicy.marriageStatus === "Married")
            // setIsMarried(clientPolicy.marriageStatus == "Married" ? true : false)
            const currentlyEmployedGWT = isGWTGenV2 ? (gwtV2FD ? (clientPolicy && (clientPolicy.currentlyEmployed === "FULL_TIME" || clientPolicy.currentlyEmployed === "PART_TIME" || clientPolicy.currentlyEmployed === "SELF_EMPLOYED")) : false) : clientPolicy && (clientPolicy.currentlyEmployed === "FULL_TIME" || clientPolicy.currentlyEmployed === "PART_TIME");
            setIsEmployed(currentlyEmployedGWT);
            setIsIndustryOther(clientPolicy && clientPolicy.industryId === otherIndustryId)
            setIndustryId(clientPolicy && clientPolicy.industryId)
            //getDays();
        }
        if (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id) {
            setCarrierId(clientPolicy.carrier.id);
            setCarrierName(clientPolicy.carrier.carrierName);
        }
        if (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug) {
            setStrategySlug(clientPolicy.strategy.slug);
        }

        if (clientPolicy && clientPolicy.employeeIdExpireDate) {
            const expireDate = moment(new Date(clientPolicy.employeeIdExpireDate));
            const currentDate = moment(new Date());
            const daysLeft = expireDate.diff(currentDate, "days");
            if (daysLeft <= 0) {
                setProofExpired(true);
            }
        }
        if (user.client && user.client.state) {
            const stateObj: any =  stateDropDown.find((item:any,index)=>{
                return item.value === user.client.state
            })
            setStateObj({
                key: stateObj && stateObj.value,
                name: stateObj && stateObj.name,
                title: stateObj && stateObj.name
            });
            setRefresh(Math.random());
        }
    }, [clientPolicy]);

    React.useEffect(()=>{
        if(personalDetailForm && personalDetailForm.current && personalDetailForm.current.dirty && autoSaveEnable && saveRequest !== -1) {
            let values:any = personalDetailForm && personalDetailForm.current && personalDetailForm.current.values;
            if (
                    ((Number(values["age"]) || Number(values["age"]) === 0) && (Number(values["age"]) < minAge ||
                            Number(values["age"]) > 65))
                    || (Number(values["age"]) < 0)
            ) {
                values.age = 0;
            }
            if(values.dob === undefined){
                values.dob = dob;
            }
            setBirthCountryValue(typeof values.birthCountry === "object" ? values.birthCountry && values.birthCountry.name : values.birthCountry);
            saveMe(values);
            setFormValues(values)
        }
    }, [saveRequest, middleNameExist]);
    //MS: Disable Auto Save For Now only on saveRequest
    // }, [personalDetailForm && personalDetailForm.current && personalDetailForm.current.values, saveRequest])

    useEffect(() => {
        if(client.birthCountry === undefined){
            setBirthCountryValue(USA);
        } else if(client.birthCountry && birthCountryValue === undefined){
            setBirthCountryValue(client.birthCountry);
        }
    }, [client, birthCountryValue]);

    const getIndustriesList = async () => {
        const allIndustries = await accountActions.getAllIndustries();
        const industriesArr = allIndustries.length > 0 && allIndustries.map((item) => {
            return {
                id: item.id,
                value: item.id,
                name: item.sectorDefinition
            }
        })
        setIndustryDropDown(industriesArr);
    }

    const getEstimation = async () => {
        if (client) {
            getContributionAmount({
                contributionAmount: 0,
                age: client.age,
                rating: clientPolicy && clientPolicy.healthType,
                gender: client && client.gender,
            });
        }
    };

    const getContributionAmount = (data: any) => {
        setTimeout(async () => {
            let isMinRequiredError = !(clientPolicy && clientPolicy.company && clientPolicy.company.groupType === "Corporation" && clientPolicy.underWritingOfferTypeFinal === "gi");

            let employerContributionValue:any = 0;
            if (clientPolicy && clientPolicy.employerContribution && numeral(clientPolicy.employerContribution).value() > 0 && props.clientDetail && props.clientDetail.role === 6) {
                employerContributionValue = clientPolicy.employerContribution;
            }
            let estimatorData: any = await estimationActions.getInvitedClientEstimates({
                age: data.age || minAge,
                gender: data.gender === 1 ? "Male" : "Female",
                rating: (data && data.rating) || "Standard",
                contribution: numeral(data.contributionAmount).value() + numeral(employerContributionValue).value() + "",
                strategySlug: (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug) || "",
                carrierName: (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.carrierName) || "",
                isMinRequiredError
            });
            if (estimatorData && estimatorData.payload && estimatorData.payload.minContributionAmount) {
                setMinVal(estimatorData && estimatorData.payload && estimatorData.payload.minContributionAmount);
            }
            if(!isMinRequiredError){
                setMinVal(0);
            }
        }, 500);
    };

    let contributionType:string | undefined = (clientPolicy && clientPolicy.company && clientPolicy.company.contributionType) || undefined;
    let showEmployerContribution: boolean = true;
    let showClientContribution: boolean = true;

    if((contributionType === 'EMPLOYER_ONLY')){
        showEmployerContribution = true;
        showClientContribution = false;
    } else if((contributionType === 'PARTICIPANT_ONLY')){
        showEmployerContribution = false;
        showClientContribution = true;
    } else if((contributionType === 'COMBINE_CONTRIBUTION')){
        showEmployerContribution = true;
        showClientContribution = true
    }


    const isCorporation:boolean = !!(clientPolicy && clientPolicy.company && clientPolicy.company.groupType === "Corporation");
    let offerType = useOfferType();
    if(offerType === "consent"){
        offerType = "gi";
    }



    let fieldObj = PersonalDetailFieldObj.fieldObj(conditionalRequired,birthStateValue,setBirthStateValue, setBirthCountryValue, clientSigned, birthCountryValue);
    const fieldObj1 = PersonalDetailFieldObj.fieldObj1(conditionalRequired, getContributionAmount, setProvideCorrectEmailPopUp, isFromClientDetail, middleNameExist, setMiddleNameExist);
    const fieldObj12 = PersonalDetailFieldObj.fieldObj12(conditionalRequired, clientSigned, setBirthStateValue, birthStateValue);
    const fieldObj13 = PersonalDetailFieldObj.fieldObj13(conditionalRequired);

    if (birthCountryValue === USA) {
        fieldObj = [...fieldObj, ...fieldObj12];
    }
    else {
        fieldObj = [...fieldObj, ...fieldObj13];
    }

    const setAnticipatedAge = (date, setValue, formValues) => {
        const age = moment().diff(date, "years");
        setAgeSelected(!!(age && (age >= minAge && age <= 65)));
        getContributionAmount({
            contributionAmount: 0,
            age: age,
            rating: formValues && formValues.healthType,
            gender: formValues && formValues.gender,
        });
        setValue("age", age);
    };

    const fieldObj4 = PersonalDetailFieldObj.fieldObj4(conditionalRequired, setAnticipatedAge, sendSaveRequest);

    const fieldObj7 = PersonalDetailFieldObj.fieldObj7(conditionalRequired, setProofExpired);
    let fieldObj2 = PersonalDetailFieldObj.fieldObj2(conditionalRequired, setStateValue, communityStateVal, clientSigned,birthCountryValue);

    let fieldObj8:any = PersonalDetailFieldObj.fieldObj8(conditionalRequired, carrierName, setCountryCitizenshipValue);
    const fieldObj10:any = PersonalDetailFieldObj.fieldObj10(conditionalRequired);
    const fieldObj11:any = PersonalDetailFieldObj.fieldObj11(setOtherCitizenshipValue);
    if(carrierName === AllianzLifeCarrierDetail.name) {
        fieldObj2 = [...fieldObj2, ...fieldObj10];
        fieldObj8 = [...fieldObj8, ...fieldObj11];
    }
    const fieldObj9 = PersonalDetailFieldObj.fieldObj9(conditionalRequired, isNfIul);
    const greenCardExpiryFieldObj = PersonalDetailFieldObj.greenCardExpiryFieldObj();
    const visaExpiryFieldObj = PersonalDetailFieldObj.visaExpiryFieldObj();
    let isGiCorpIncomeCond:boolean = !!fullTimeEmployee || (offerType === "gi-to-full" || offerType === "si-to-full");

    const fieldObj3 = PersonalDetailFieldObj.fieldObj3(isGiCorpIncomeCond, conditionalRequired, currentYear, offerType
            , strategySlug, nationalLifeId, carrierId, fullTimeSelected, industryDropDown, setIsIndustryOther, setIndustryId, occupationDropDownArr, isEmployed);
    const fieldObj5 = PersonalDetailFieldObj.fieldObj5(isGiCorpIncomeCond, conditionalRequired,isGWTGen2)

    const fieldObj6 = PersonalDetailFieldObj.fieldObj6(conditionalRequired, client, ageSelected, getContributionAmount)

    const getFieldFocusValue = (name: string) => {
        let findResult: any = labelsActive.find((label: any) => {
            return label.name === name;
        });
        if (!findResult) {
            return false;
        }

        return findResult.value;
    };

    const CommonField = (

            filedProps,
            action: {
                handleChange?: Function,
                handleBlur: Function,
                values?: any,
                errors?: any,
                touched?: any,
                setFieldValue: any
            },
    ) => {
        return (
                <CommonFieldFunction filedProps={filedProps}
                                     action={action}
                                     conditionalRequired={conditionalRequired}
                                     role={role}
                                     setActionItem={setActionItem}
                                     client={client}
                                     labelsActive={labelsActive}
                                     setLabelsActive={setLabelsActive}
                                     clientSigned={clientSigned}
                                     getFieldFocusValue={getFieldFocusValue}

                />)
    };

    /* Validations of fields set */
    let keysValidation = {};
    let fieldobj10 = [
        {
            name: "householdNetWorth",
            isRequired: true,
            type: "number",
        },
        {
            name: "spouseDUAIncome",
            isRequired: true,
            type: "number",
        },
        {
            name: "householdLiquidAssets",
            isRequired: true,
            type: "number",
        },
        {
            name: "householdAnnualExpenses",
            isRequired: true,
            type: "number",
        },
    ];

    let validationObj = [
        ...fieldObj,
        ...fieldObj1,
        ...fieldObj4,
        {
            name: "currentlyEmployed",
            isRequired: conditionalRequired && !( isCorporation && (offerType === "gi"  || offerType === "consent" || offerType === "si") ),
            type:"string"
        },
        {
            name: "marriageStatus",
            isRequired: conditionalRequired && !isMarried,
            type:"string"
        },
        {
            name: "spouse",
            isRequired: isMarried,
            type: "string",
        },
        {
            name: "usingSpouseIncome",
            isRequired: conditionalRequired && isMarried && !isGWTGen2,
            type:"string"
        },
        //isEmployed
        {
            name: "employer",
            isRequired: conditionalRequired && isEmployed,
            type:"string"
        },{
            name: "employedTime",
            isRequired: conditionalRequired && isEmployed,
            type:"string"
        },{
            name: "occupation",
            isRequired: conditionalRequired && isEmployed && isIndustryOther,
            type:"string"
        },
        {
            name: "industryId",
            isRequired: conditionalRequired && isEmployed,
            type:"number"
        },{
            name: "otherIndustry",
            isRequired: conditionalRequired && isEmployed && isIndustryOther,
            type:"string"
        },{
            name: "occupationId",
            isRequired: conditionalRequired && isEmployed && !isIndustryOther,
            type:"number"
        },{
            name: "otherOccupation",
            isRequired: conditionalRequired && isEmployed && isIndustryOther,
            type:"string"
        },{
            name: "occupationDetail",
            isRequired: conditionalRequired && isEmployed,
            type:"string"
        },
        {
            name: "parentsAreIncomeEarner",
            isRequired: (conditionalRequired && currentlyEmployed && currentlyEmployed === "Other" && isParentEarner && !isAllianzLife),
            type:"string"
        }];

    if ((isLongForm(offerType) || isWorksheet(offerType)) && isMarried) {
        validationObj = [...validationObj, ...fieldobj10];
    }

    if(isLongForm(offerType) || isWorksheet(offerType)){
        validationObj.push(
                {
                    name: "highRanking",
                    isRequired: conditionalRequired,
                    type:"number"
                },
                {
                    name: "individualHighRanking",
                    isRequired: conditionalRequired,
                    type:"number"
                },
                {
                    name: "workInIndustries",
                    isRequired: conditionalRequired,
                    type:"number"
                },
                {
                    name: "employerAddress",
                    isRequired: conditionalRequired,
                    type:"string"
                },
                {
                    name: "countryOfOrigin",
                    isRequired: conditionalRequired,
                    type:"string"
                },
                {
                    name: "sourceOfFunds",
                    isRequired: conditionalRequired,
                    type:"string"
                },
                {
                    name: "countrySourceOfWealth",
                    isRequired: conditionalRequired,
                    type:"string"
                },
                {
                    name: "whereTheyProceed",
                    isRequired: conditionalRequired,
                    type:"string"
                }
        );
    }

    if (isGWTGenV2 && !financiallyDependent && ((formValues.currentlyEmployed === "FULL_TIME") || (formValues.currentlyEmployed === "PART_TIME") || (formValues.currentlyEmployed === "SELF_EMPLOYED"))) {
        validationObj.push(
                {
                    name: "indIncomeLastYearAnnualSalary",
                    isRequired: true,
                    type: "number",
                },
                {
                    name: "indIncome1YearsPriorAnnualSalary",
                    isRequired: true,
                    type: "number",
                },
                {
                    name: "indIncome2YearsPriorAnnualSalary",
                    isRequired: true,
                    type: "number",
                },
                {
                    name: "netWorth",
                    isRequired: true,
                    type: "number"
                }
        );
    }

    keysValidation = PersonalDetailValidate(validationObj, keysValidation, isFromClientDetail, minAge, fieldObj9, fieldObj8,
            fieldObj2, fieldObj3, offerType, isGiCorpIncomeCond, strategySlug, client, ageSelected, minVal,
            showClientContribution, fieldObj6, fieldObj7, fullTimeSelected, props, formValues,visaExpiryFieldObj, greenCardExpiryFieldObj, isGiftor
    );
    const personalDetailSchema = Yup.object().shape(keysValidation);

    let kickOutDetail = {
        groupAdminEmail: (clientPolicy && clientPolicy.agent && clientPolicy.agent.user && clientPolicy.agent.user.email) || "",
        groupAdminPhone : (clientPolicy && clientPolicy.agent && clientPolicy.agent.user && clientPolicy.agent.user.phoneNumber) || "",
        groupAdminFullName : (clientPolicy && clientPolicy.agent && clientPolicy.agent.user && clientPolicy.agent.user.firstName + ' ' + clientPolicy.agent.user.lastName) || "",
        strategyName : (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.name) || ""
    }
    if(role === 6){
        kickOutDetail = {
            groupAdminEmail: (clientPolicy && clientPolicy.company && clientPolicy.company.email) || "",
            groupAdminPhone : (clientPolicy && clientPolicy.company && clientPolicy.company.phone) || "",
            groupAdminFullName : (clientPolicy && clientPolicy.company && clientPolicy.company.companyName) || "",
            strategyName : (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.name) || ""
        }
    }

    const participantId:number = (participant && participant.id) || 0;

    // closure function for make payload
    const makePersonalDetailPayloadOnlyTouchedValues =  (values: any, setInitialValues: any, autoSave = false ,touched:any = {}) => {
        const payload = makePersonalDetailPayload(values, setInitialValues, autoSave, touched);
        // allow only touched to send in request of saving request
        let changedValuesFromInitValues = {}

        let touchedKeys =  Object.keys(touched)
        // comparison with initValues to check changes or not
        touchedKeys =  touchedKeys.filter((key)=> {
            if(personalDetailForm.current.values[key] !== initialValues[key]){
                // comparison on objects
                return !(typeof initialValues[key] == "object" && JSON.stringify(initialValues[key]) === JSON.stringify(personalDetailForm.current.values[key]));
            }
        })
        touchedKeys.forEach(key => {
            changedValuesFromInitValues[key] = payload[key];
        })
        return changedValuesFromInitValues;
    }

    const makePersonalDetailPayload = (values:any, setInitialValues:any, autoSave= false, touched:any= {}) => {
        if (isCorporation && (offerType === "gi" || offerType === "si") && !values["fullTimeEmployee"] && !isFromClientDetail) {
            setOpenKickOutPopup(true);
            return false;
        }
        delete values["employerContribution"];
        setIsFormSubmit(true);
        if (!isFromClientDetail && proofExpired) {
            return false;
        }
        // if (isFromClientDetail && (values["age"] < minAge || values["age"] > 65) && values["birthDay"] && values["birthMonth"] && values["birthYear"]) {
        //     let { birthDay, birthMonth } = values;
        //     delete values.age;
        //     delete values.birthDay;
        //     delete values.birthMonth;
        //     delete values.birthYear;
        //     if(setInitialValues && typeof setInitialValues === 'function') {
        //         setInitialValues({
        //             ...values,
        //             age: initialValues.age,
        //             birthDay: birthDay,
        //             birthYear: initialValues.birthYear,
        //             birthMonth: birthMonth,
        //         });
        //     }
        // } else {
            if(setInitialValues && typeof setInitialValues === 'function') {
                setInitialValues(values);
            }
        //}

        if (role === 5 || role === 6) {
            delete values["contributionAmount"];
            delete values["healthType"];
        } else {
            values["contributionAmount"] = values["contributionAmount"] ? values["contributionAmount"].split(",").join("") : 0;
        }
        if (!isFromClientDetail && values["age"] === 0 && !autoSave) {
            return false;
        }

        //values["annualIncome1"] = values["annualIncome1"] ? values["annualIncome1"] : null;
        //values["annualIncome2"] = values["annualIncome2"] ? values["annualIncome2"] : null;
        values["employedTime"] = values["employedTime"] ? values["employedTime"] : 0;
        values["employer"] = values["employer"] ? values["employer"] : "";
        values["annualIncome"] = values["indIncomeLastYearAnnualSalary"] && Number(values["indIncomeLastYearAnnualSalary"]) !== 0 ? values["indIncomeLastYearAnnualSalary"].split(",").join("") : null;
        values["annualIncome1"] = values["indIncome1YearsPriorAnnualSalary"] && Number(values["indIncome1YearsPriorAnnualSalary"]) !== 0 ? values["indIncome1YearsPriorAnnualSalary"].split(",").join("") : null;
        values["annualIncome2"] = values["indIncome2YearsPriorAnnualSalary"] && Number(values["indIncome2YearsPriorAnnualSalary"]) !== 0 ? values["indIncome2YearsPriorAnnualSalary"].split(",").join("") : null;
        values["householdAnnualIncome"] = convertToNumber(values["houseHoldIncomeLastYearAnnualSalary"]);
        values["householdNetWorth"] = convertToNumber(values["householdNetWorth"]);
        values["spouseDUAIncome"] = convertToNumber(values["spouseDUAIncome"]);
        values["householdLiquidAssets"] = convertToNumber(values["householdLiquidAssets"]);
        values["householdAnnualExpenses"] = convertToNumber(values["householdAnnualExpenses"]);
        values["dob"] = asDbDateTimeFormat(values["dob"], DATE_FORMAT_DOB_SAVE);
                //income details field starts
        values["spouseIncome"] = convertToNumber(values["spouseIncome"]);
        incomeDetailsColArr.forEach((item) => {
            const stringBased = typeof values[`${item}`] === "string"
                    ? values[`${item}`].split(",").join("")
                    : String(values[`${item}`] || "").split(",").join("");
            values[`${item}`] = values[`${item}`] ? stringBased : null;
        }); //income details field end
        values["netWorth"] = convertToNumber(values["netWorth"]);
        values["homePhone"] = convertToNumber(values["homePhone"]);
        values["immigrationStatus"] = values["immigrationStatus"] ? values["immigrationStatus"] : "";
        values["state"] = typeof values["state"] === "object" ? values["state"] && values["state"].key : values["state"];
        return values;
    }

    const saveMe = async (values:any) => {
            const payload:any = makePersonalDetailPayload(values,null, true);
            try {
                if (payload) {
                    payload.age = Number(payload.age);
                    if (!clientSigned) {
                        await accountActions.updateUserBasicDetails(payload, ((clientPolicy && clientPolicy.id) || 0), "");
                    }
                }
            } catch (e) {
                //MS Commented as its creating repeating error
                // if (e && e.message == 422 && (typeof getClientDetail === 'function')) {
                //     getClientDetail(urlClientId || 0, clientPolicyId, ssnFlag);
                //     setServerError(true);
                // }
                return false;
            }
    }

    //const { values, submitForm } = useFormikContext();
    return (
            <>
                {isGiCorpIncomeCond &&
                        <IncomeAlert incomeAlertOpen={incomeAlertOpen} />
                }
                <KickOut participantId={participantId} isFromClientDetail={isFromClientDetail || false}
                         openKickOut={openKickOutPopup} setOpenKickOut={() => {
                    setOpenKickOutPopup(!openKickOutPopup)
                }} {...kickOutDetail} />
                <PersonalDetailFormikContent
                        initialValues={initialValues}
                        personalDetailSchema={personalDetailSchema}
                        isCorporation={isCorporation}
                        offerType={offerType}
                        setOpenKickOutPopup={setOpenKickOutPopup}
                        setIsFormSubmit={setIsFormSubmit}
                        isFromClientDetail={isFromClientDetail}
                        proofExpired={proofExpired}
                        isNationalLife={isNationalLife}
                        selfEmployed={selfEmployed}
                        minAge={minAge}
                        setInitialValues={setInitialValues}
                        setNextStep={setNextStep}
                        client={client}
                        setActionItem={setActionItem}
                        role={role}
                        setIsPersonalFormDirty={setIsPersonalFormDirty}
                        setIsFormSubmitting={setIsFormSubmitting} setFullTimeEmployee={setFullTimeEmployee}
                        fullTimeEmployee={fullTimeEmployee}
                        setIncomeAlertOpen={setIncomeAlertOpen} setCurrentlyEmployed={setCurrentlyEmployed}
                        setValidationError={setValidationError} setSelfEmployed={setSelfEmployed}
                        accountActions={accountActions}
                        setOpenAlert={setOpenAlert}
                        user={user}
                        fieldObj={fieldObj}
                        clientSigned={clientSigned}
                        conditionalRequired={conditionalRequired} setProofExpired={setProofExpired}
                        CommonField={CommonField}
                        fieldObj1={fieldObj1} fieldObj8={fieldObj8} classes={classes} fieldObj2={fieldObj2}
                        proofExpireRef={proofExpireRef} fieldObj4={fieldObj4} fieldObj7={fieldObj7}
                        fieldObj9={fieldObj9}
                        strategySlug={strategySlug} fieldObj3={fieldObj3} fieldObj5={fieldObj5} fieldObj6={fieldObj6}
                        clientDetail={props.clientDetail} showClientContribution={showClientContribution}
                        showEmployerContribution={showEmployerContribution} minVal={minVal}
                        personalDetailSubmit={personalDetailSubmit}
                        setFullTimeSelected={setFullTimeSelected}
                        fullTimeSelected={fullTimeSelected}
                        setIsDocumentAddress={setIsDocumentAddress}
                        setIsMarried={setIsMarried}
                        setIsEmployed={setIsEmployed}
                        isAllianzLife={isAllianzLife}
                        setIsParentEarner={setIsParentEarner}
                        isParentEarner={isParentEarner}
                        personalDetailForm={personalDetailForm}
                        // autoSaveEnable only disable in enrollment-tab
                        makePersonalDetailPayload={autoSaveEnable ? makePersonalDetailPayload : makePersonalDetailPayloadOnlyTouchedValues}
                        sendSaveRequest={sendSaveRequest}
                        getClientDetail={getClientDetail}
                        urlClientId={urlClientId}
                        ssnFlag={ssnFlag}
                        setServerError={setServerError}
                        serverError={serverError}
                        setAnticipatedAge={setAnticipatedAge}
                        birthCountryValue={birthCountryValue}
                        clientPolicyId={clientPolicyId}
                        currentlyEmployed={currentlyEmployed}
                        greenCardExpiryFieldObj={greenCardExpiryFieldObj}
                        visaExpiryFieldObj={visaExpiryFieldObj}
                />

                <AllianzAlert setOpenAlert={setOpenAlert} open={openAlert} carrierName={carrierName}
                              isNationalLife={isNationalLife} />
                {
                    provideCorrectEmailPopUp &&
                        <UpdateEmailReqPopUp open={provideCorrectEmailPopUp} setProvideCorrectEmailPopUp={setProvideCorrectEmailPopUp} />
                }
            </>);
};

export default PersonalDetailFormV2;